import { ref, computed, toValue, watch } from 'vue';

import { WINDOW_HEIGHT, WINDOW_WIDTH } from '../constants/window-properties';

export function useShare(url, title) {
    const windowLocation = ref('');
    const documentTitle = ref('');
    const windowProperties = ref('');

    function getWindowProperties() {
        const top = Math.max(0, window.innerHeight / 2 - WINDOW_HEIGHT / 2),
            left = Math.max(0, window.innerWidth / 2 - WINDOW_WIDTH / 2),
            width = Math.min(WINDOW_WIDTH, window.innerWidth),
            height = Math.min(WINDOW_HEIGHT, window.innerHeight);

        return `height=${height}, width=${width}, top=${top}, left=${left}, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`;
    }

    documentTitle.value = document?.title;
    windowLocation.value = window?.location?.href;
    windowProperties.value = getWindowProperties();

    // The message to share
    const shareMessage = computed(() => {
        return toValue(title) || documentTitle.value;
    });

    // The url to share
    const shareLink = computed(() => {
        return toValue(url) || windowLocation.value;
    });

    // Check if this button can share
    // We need a share-link to share
    const canShare = computed(() => {
        return !!toValue(shareLink);
    });

    // The encoded share message
    const encodedMessage = computed(() => {
        return encodeURIComponent(toValue(shareMessage));
    });

    // The encoded share url
    const encodedUrl = computed(() => {
        return encodeURIComponent(toValue(shareLink));
    });

    // An encoded version of the message and url combined
    const encodedFull = computed(() => {
        return toValue(shareMessage) ? encodeURIComponent(`${toValue(shareMessage)} - ${toValue(shareLink)}`) : toValue(encodedUrl);
    });

    return {
        windowLocation,
        windowProperties,
        documentTitle,
        canShare,
        shareMessage,
        shareLink,
        encodedMessage,
        encodedUrl,
        encodedFull
    };
}
